import { Button, Dropdown, Form, Input, Label, Segment } from 'semantic-ui-react'
import Play from '../../components/Play'
import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import injectSheet from 'react-jss'

const recordStyles = {
	metricInput: {
		'margin-bottom': '10px'
	},
	metricRemove: {
		'margin-left': '0.5em !important'
	},
	metricAddButton: {
		'margin-bottom': '10px !important',
		'margin-right': '10px !important'
	},
	variationsDropdown: {
		'font-size': '1.42857143rem !important'
	}
}
function RecordRaw({
	metrics,
	addMetric,
	setMetric,
	removeMetric,
	metricAddOptions,

	addTagAsSelected,
	setSelectedTags,
	selectedTags,
	myTags,

	recordingVideo,
	setRecordingVideo,
	setRecordedVideoBlobs,
	recordedVideoBlobs,
	playingRecordedVideo,
	setPlayingRecordedVideo,

	exercise,
	classes
}) {
	const recordOrPlay = playingRecordedVideo
		? <Play
				blobs={recordedVideoBlobs}
				onComplete={() => setPlayingRecordedVideo(false)}
			/>
		: recordedVideoBlobs
			? <div>
					<Button
						primary
						content="Playback"
						icon="video play"
						size="huge"
						onClick={() => setPlayingRecordedVideo(true)}
					/>
					<br />
					<br />
					<Button
						secondary
						content="Delete"
						size="huge"
						icon="remove"
						onClick={() => setRecordedVideoBlobs()}
					/>
				</div>
			: <Button
					content="Record"
					primary
					size="huge"
					icon="video camera"
					onClick={() => setRecordingVideo(true)}
				/>

	return (
		<Segment basic>
			<h2>Metrics</h2>
			<Form onSubmit={ev => ev.preventDefault()}>
				{_.map(metrics, (val, metric) =>
					<Input
						key={metric}
						className={classes.metricInput}
						fluid
						value={val}
						onChange={(ev, el) => setMetric(metric, el.value)}
						labelPosition="right"
						size="big"
						min="0"
						type="number"
					>
						<input />
						<Label>{metric}</Label>
						<Button className="hidden" onClick={_.noop} />
						<Button
							className={classes.metricRemove}
							size="big"
							icon="remove"
							onClick={() => removeMetric(metric)}
						/>
					</Input>
				)}

				{_.map(metricAddOptions, option =>
					<Button
						className={classes.metricAddButton}
						key={option.key}
						primary
						icon="write"
						size="huge"
						labelPosition="left"
						content={option.text}
						onClick={ev => {
							ev.preventDefault()
							addMetric(option.value)
						}}
					/>
				)}
			</Form>

			<h2>Variations</h2>
			<Dropdown
				className={classes.variationsDropdown}
				options={_.map(_.union(selectedTags, myTags), myTag => ({
					key: myTag,
					text: myTag,
					value: myTag
				}))}
				placeholder="Pick/add variation(s)"
				search
				size="huge"
				selection
				fluid
				multiple
				allowAdditions
				value={selectedTags}
				onAddItem={(e, { value }) => {
					addTagAsSelected(value)
				}}
				onChange={(e, { value }) => {
					setSelectedTags(value)
				}}
			/>

			<h2>Video</h2>
			{recordOrPlay}

		</Segment>
	)
}
RecordRaw.propTypes = {
	metrics: PropTypes.object.isRequired,
	addMetric: PropTypes.func.isRequired,
	setMetric: PropTypes.func.isRequired,
	removeMetric: PropTypes.func.isRequired,
	metricAddOptions: PropTypes.arrayOf(PropTypes.object).isRequired,

	addTagAsSelected: PropTypes.func.isRequired,
	setSelectedTags: PropTypes.func.isRequired,
	selectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
	myTags: PropTypes.arrayOf(PropTypes.string).isRequired,

	recordingVideo: PropTypes.bool.isRequired,
	setRecordingVideo: PropTypes.func.isRequired,
	setRecordedVideoBlobs: PropTypes.func.isRequired,
	recordedVideoBlobs: PropTypes.arrayOf(PropTypes.object),
	playingRecordedVideo: PropTypes.bool.isRequired,
	setPlayingRecordedVideo: PropTypes.func.isRequired,

	exercise: PropTypes.shape({ title: PropTypes.string }),
	classes: PropTypes.object
}
const Record = injectSheet(recordStyles)(RecordRaw)

export default Record



// WEBPACK FOOTER //
// ./src/pages/Do/Record.js